/**
 * MSDS 관리대장(HAM_BASIC_02) 컬럼 정의
 * HAM_BASIC_02 화면 전용 컬럼 정의
 */

import { CreateColumn } from '../../../../Services/agGrid/createColumn';

/**
 * MSDS 관리대장 Master 컬럼 정의 생성
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    // 체크박스 컬럼 (NO 컬럼)
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow1,
        RestoreRow: props.RestoreRow1,
        gridRef: props.gridRef1,
        rowData: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef1,
        lastCheckedIndexRef: props.lastCheckedIndexRef1,
        handleRowSelection: props.handleRowSelection1,
      },
      maxWidth: 100,
    }),
    // 제품명 컬럼 (필수)
    CreateColumn(
      'productName',
      '제품명',
      'left',
      200,
      true,
      true,
      false,
      'text',
      {
        maxLength: 200,
      }
    ),
    // 취급공종 컬럼 (필수)
    CreateColumn(
      'processType',
      '취급공종',
      'left',
      150,
      true,
      true,
      false,
      'text',
      {
        maxLength: 100,
      }
    ),
    // 작업자명 컬럼
    CreateColumn('workerName', '작업자명', 'left', 150, true, false, false, 'text', {
      maxLength: 100,
    }),
    // 최초진단 개월 컬럼
    CreateColumn(
      'firstExamMonths',
      '최초진단 개월',
      'center',
      150,
      true,
      false,
      false,
      'number',
      {
        valueParser: (params) => {
          const raw = params.newValue?.toString().replace(/[^0-9]/g, '') || '';
          let parsed = parseInt(raw, 10);
          return isNaN(parsed) ? null : Math.min(parsed, 2147483647);
        },
        valueFormatter: (params) => {
          return params.value ?? '';
        },
      }
    ),
    // 특수건강진단 주기 (개월) 컬럼 (필수)
    CreateColumn(
      'examCycleMonths',
      '특수건강진단 주기 (개월)',
      'center',
      200,
      true,
      true,
      false,
      'number',
      {
        valueParser: (params) => {
          const raw = params.newValue?.toString().replace(/[^0-9]/g, '') || '';
          let parsed = parseInt(raw, 10);
          return isNaN(parsed) ? null : Math.min(parsed, 2147483647);
        },
        valueFormatter: (params) => {
          return params.value ?? '';
        },
      }
    ),
    // 배포처/연락처 컬럼 (필수)
    CreateColumn(
      'distributionContact',
      '배포처/연락처',
      'left',
      200,
      true,
      true,
      false,
      'text',
      {
        maxLength: 200,
      }
    ),
    // 경고표지 첨부 컬럼 (필수, fileButton)
    CreateColumn(
      'warningLabelFileName',
      '경고표지 첨부',
      'center',
      200,
      false,
      true,
      false,
      'fileButton',
      {
        fileButtonClickHandler: (data, fieldName) => {
          props.PopupClickEvent1?.(data);
        },
        fileButtonFileNameKey: 'warningLabelFileName',
        fileButtonFilePathKey: 'warningLabelFilePath',
        cellClassRules: {
          'required-cell': (params) => {
            const value = params.value;
            if (!value) return true;
            if (typeof value === 'string') return value.trim() === '';
            return true;
          },
        },
      }
    ),
    // 경고표지 경로 컬럼 (숨김)
    CreateColumn('warningLabelFilePath', '경고표지 경로', 'left', 200, false, false, true, 'text'),
    // 비고 컬럼
    CreateColumn('remark', '비고', 'left', 200, true, false, false, 'text', {
      maxLength: 500,
    }),
    // HBM_ID 컬럼 (숨김)
    CreateColumn('hbmId', 'HBM_ID', 'left', 100, false, false, true, 'text'),
    // 미리보기 파일 경로 컬럼 (숨김)
    CreateColumn(
      'previewFilePath',
      '미리보기 파일 경로',
      'left',
      200,
      false,
      false,
      true,
      'text',
      {
        flex: 1,
      }
    ),
  ];
};

/**
 * MSDS 관리대장 Detail 컬럼 정의 생성
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs2 = () => {
  return [
    // 체크박스 컬럼 (NO 컬럼)
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      maxWidth: 100,
    }),
    // 물질명 컬럼 (필수)
    CreateColumn('substanceName', '물질명', 'left', 200, true, true, false, 'text', {
      maxLength: 200,
    }),
    // CAS NO. 컬럼 (필수)
    CreateColumn('casNo', 'CAS NO.', 'left', 150, true, true, false, 'text', {
      maxLength: 50,
    }),
    // 함유율 컬럼
    CreateColumn('contentPercent', '함유율', 'center', 120, true, false, false, 'number', {
      valueFormatter: (params) => {
        return params.value ?? '';
      },
    }),
    // 관리대상 컬럼 (체크박스, Y/N 값)
    CreateColumn(
      'managementTarget',
      '관리대상',
      'center',
      120,
      true,
      false,
      false,
      'checkbox'
    ),
    // 특별관리 컬럼 (체크박스, Y/N 값)
    CreateColumn(
      'specialManagement',
      '특별관리',
      'center',
      120,
      true,
      false,
      false,
      'checkbox'
    ),
    // 작업환경측정 컬럼 (체크박스, Y/N 값)
    CreateColumn(
      'workEnvMeasurement',
      '작업환경측정',
      'center',
      150,
      true,
      false,
      false,
      'checkbox'
    ),
    // 특수건강진단 컬럼 (체크박스, Y/N 값)
    CreateColumn(
      'specialHealthExam',
      '특수건강진단',
      'center',
      150,
      true,
      false,
      false,
      'checkbox'
    ),
    // 허가대상 컬럼 (체크박스, Y/N 값)
    CreateColumn(
      'permissionTarget',
      '허가대상',
      'center',
      120,
      true,
      false,
      false,
      'checkbox'
    ),
    // HBD_ID 컬럼 (숨김)
    CreateColumn('hbdId', 'HBD_ID', 'left', 100, false, false, true, 'text'),
    // HBM_ID 컬럼 (숨김)
    CreateColumn('hbmId', 'HBM_ID', 'left', 100, false, false, true, 'text'),
  ];
};

const columnDefs = {
  getColumnDefs1,
  getColumnDefs2,
};

export default columnDefs;
